<mat-card>
	<mat-card-content>
		<form [formGroup]="capacitySearchFilterForm" style="width: 100%">
			<div class="padding-0-5" fxLayoutGap="1rem">
				<div class="border-right p-r-1" fxFlex fxLayoutAlign="center center">
					<span class="primary-text font-size-14">
						<b
							(click)="
								currentCapacityFilter != RANGE_FILTERS.SORT.MATCH
									? sortSearchList(RANGE_FILTERS.SORT.MATCH)
									: ''
							"
							[ngStyle]="getStyle(RANGE_FILTERS.SORT.MATCH)"
						>
							Best Match: {{ BEST_MATCH }}
						</b>
					</span>
				</div>

				<div class="border-right" fxFlex fxLayoutAlign="center center">
					<span class="primary-text font-size-14">
						<b
							(click)="
								currentCapacityFilter != RANGE_FILTERS.SORT.FREQUENCY
									? sortSearchList(RANGE_FILTERS.SORT.FREQUENCY)
									: ''
							"
							[ngStyle]="getStyle(RANGE_FILTERS.SORT.FREQUENCY)"
						>
							Frequency
						</b>
					</span>
				</div>

				<div class="border-right p-r-1" fxFlex fxLayoutAlign="center center">
					<mat-form-field>
						<mat-label>Carrier HQ</mat-label>
						<mat-select formControlName="carrierHQ">
							<mat-option *ngFor="let option of carrierHQOptions" [value]="option">
								{{ option }}
							</mat-option>
						</mat-select>
					</mat-form-field>
					<mat-icon
						(click)="
							capacitySearchFilterForm.get('carrierHQ').setValue('');
							carrierHQList = null;
							updateCarrierHQFilter()
						"
						*ngIf="capacitySearchFilterForm.get('carrierHQ').value.length > 1"
						class="danger-text cursor-pointer"
					>
						close
					</mat-icon>
				</div>

				<div class="border-right p-r-1" fxFlex fxLayoutAlign="center center">
					<mat-form-field>
						<mat-select formControlName="carrierSelected">
							<mat-option *ngFor="let option of carriersFilterOptions" [value]="option">
								{{ option }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div
					[ngClass]="{ 'border-right': inCapacitySearch && productsService.PROJECT_CARRIERS }"
					class="p-r-1"
					fxFlex
					fxLayoutAlign="center center"
				>
					<mat-form-field>
						<mat-select formControlName="filterSelected">
							<mat-option *ngFor="let option of truckFilterOptions" [value]="option">
								{{ option }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div *ngIf="inCapacitySearch" fxFlex fxLayoutAlign="center center">
					<app-load-details-form
						*ngIf="isBaEnabled()"
						[buttonText]="'Get Options'"
						[customerCarrierMatched]="customerCarrierMatched"
						[disabled]="isGetOptionsDisabled()"
						(isSearchRefined)="getSearchRefined($event)"
						[emailByTruckIds]="emailByTruckIds"
						[inNetworkCarrierCountForSearch]="inNetworkCarrierCountForSearch"
						[lanePricing]="lanePricing"
						[matTooltip]="isGetOptionsDisabled() ? getOptionsTooltip() : ''"
						[matchedCarriers]="matchedCarriers"
						[matchedCarrierIds]="matchedCarrierIds"
						[searchTruckForm]="searchTruckForm"
						[truckLaneSearchId]="truckLaneSearchId"
						[truckSearchIds]="truckSearchIds"
						[useButton]="true"
						matTooltipClass="custom-tooltip"
						[isCityMissing]="isCityMissing"
					>
					</app-load-details-form>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>
